import "./Shop.css";
import { FaInstagram } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import GalleryDataShop from "./GalleryDataShop";

const galleryData = {
  all: {
    blackWoman: ["Loneliness", "65x90cm acrylic on canvas", "70€"],
    medusa: ["Medusa", "65x90cm acrylic on canvas", "100€"],
    watercolorManCrying: ["Man crying", "30x40cm sketch with watercolour", "30€"],
    "2acrylicpaintings": ["Lonely figure", "2x 15x15cm acrylic on canvas", "40€"],
    watercolorWoman4: [undefined, "20x30cm watercolor painting", "30€"],
    watercolorWoman2: [undefined, "20x30cm acrylic on canvas", "30€"],
  },
};

const Shop = () => {
  const imageKeys = Object.keys(galleryData.all);

  return (
    <div>
      {/* Header */}
      <div className="d-flex pt-5">
        <div className="headerContainer w-100" style={{ backgroundColor: "transparent" }}>
          <div className="logoContainer">
            <h1 className="logo">KAIPI MARIA</h1>
          </div>
          <div className="d-flex menuBar">
            <Link to="/" className="nav-item nav-link" id="homeBtn">Home</Link>
            <Link to="/Gallery" className="nav-item nav-link" id="Gallery">Gallery</Link>
            <Link to="/AboutMe" className="nav-item nav-link" id="AboutMeBtn">AboutMe</Link>
            <Link to="/Contact" className="nav-item nav-link" id="ContactBtn">Contact</Link>
            <Link to="/Shop" className="nav-item nav-link active" id="ShopBtn" style={{ textDecoration: "underline" }}>
              Shop
            </Link>
          </div>
        </div>
      </div>

      {/* Title */}
      <div className="row text-center mt-5">
          <h2>Available Originals</h2>
          <h5 className="mt-2">acrylics on canvas, watercolors and sketches</h5>
      </div>

      {/* Grid */}
      <div className="row mt-3">
        <div className="col-12">
          <GalleryDataShop imageKeys={imageKeys} galleryData={galleryData.all} />
        </div>
      </div>

      {/* Social */}
      <div className="block-layout position-relative justify-content-center mt-5">
        <a href="https://www.instagram.com/kaipimaria_art/" className="socialIcons"><FaInstagram size={30} /></a>
        <a href="https://www.facebook.com/profile.php?id=100012918557813" className="socialIcons"><FaFacebook size={30} /></a>
        <a href="mailto:kaiphmaria001@gmail.com" className="socialIcons"><MdOutlineEmail size={30} /></a>
      </div>
    </div>
  );
};

export default Shop;
